<div pRipple class="card h-full" (click)="actionClick()">
    <div class="card-body h-full">
        <ng-content></ng-content>
    </div>
</div>